  function loadTidio() {
  if (window.tidioInitialized) return;

  window.tidioInitialized = true;

  const script = document.createElement('script');
  script.src = 'https://code.tidio.co/edxgtzngohipc999d9zq5xvgtjseduwi.js';
  script.async = true;
  document.body.appendChild(script);
}

['pointerdown', 'touchstart', 'keydown'].forEach((eventName) => {
  window.addEventListener(eventName, loadTidio, {
    once: true,
    passive: true
  });
});

window.setTimeout(loadTidio, 3000);


 function onTidioChatApiReady() {

    const path = window.location.pathname;

    if (!path.includes('/products/')) return;  // ✅ solo se l’URL contiene /blog/

        tidioChatApi.adjustStyles(`
        #tidio, #tidio-chat-root { bottom: 0px !important; }
        `);

        tidioChatApi.adjustStyles(`
        @media only screen and (max-width: 980px) {
            #tidio, #tidio-chat-root { bottom: 50px !important; }
        }
        `);
    }

    if (window.tidioChatApi) {
        window.tidioChatApi.on('ready', onTidioChatApiReady);
    } else {
        document.addEventListener('tidioChat-ready', onTidioChatApiReady);
 }